var map = {
	"./404.png": "CgFv",
	"./GBCInteraction.png": "glSm",
	"./address_lp.png": "JlQP",
	"./address_ts.png": "0cS/",
	"./addressicon.png": "krZR",
	"./announcements.png": "+yKB",
	"./announcements@2x.png": "I4q/",
	"./appqrcode_lp.png": "qVnz",
	"./appqrcode_ts.png": "L9HL",
	"./approverManage@2x.png": "jaWm",
	"./banner.png": "P07D",
	"./batp.png": "kiKz",
	"./booking@2x.png": "iPkg",
	"./building.png": "guhP",
	"./componyBank.png": "ce2R",
	"./declaration.png": "QcXz",
	"./del.png": "stew",
	"./down.png": "rix4",
	"./edit.png": "KObk",
	"./empty.png": "Bm30",
	"./flowone.png": "NI/Q",
	"./intfour.png": "lrlx",
	"./intrthree.png": "eL4l",
	"./logo.png": "iQH9",
	"./maptwo.png": "i5bw",
	"./more.png": "MprZ",
	"./moreinfor.png": "/IaA",
	"./newDev.png": "VXIQ",
	"./newStyle.png": "7F2N",
	"./noPic.png": "fMpN",
	"./nodata.png": "f0hK",
	"./notice.png": "6RTL",
	"./onlineService@2x.png": "nwsN",
	"./policy.png": "9oXb",
	"./read.png": "9UP6",
	"./telicon.png": "onr0",
	"./test.jpg": "p6y8",
	"./thridparty.png": "UhhF",
	"./up.png": "qY3/",
	"./zqyhd.png": "TnsX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 29